var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Pin_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pin_svg__b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 29,
    fill: "#000",
    fillOpacity: 0.12,
    rx: 4,
    ry: 2
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EA382E",
    d: "M17.916 20.063A9.986 9.986 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.986 9.986 0 0 0 4.084 8.063c1.882 1.418 4.535 3.655 5.145 7.257.064.381.384.677.771.677s.707-.296.771-.677c.61-3.602 3.263-5.839 5.145-7.257Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#Pin_svg__c)",
    d: "M18.214 20.464A10.486 10.486 0 0 0 22.5 12c0-5.799-4.701-10.5-10.5-10.5S1.5 6.201 1.5 12c0 3.474 1.688 6.554 4.286 8.464 1.874 1.413 4.375 3.547 4.95 6.939.101.598.61 1.094 1.264 1.094s1.163-.496 1.264-1.094c.575-3.392 3.076-5.526 4.95-6.939Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4,
    fill: "#000",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Pin_svg__c",
    x1: 12,
    x2: 12,
    y1: 2,
    y2: 27.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Pin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v32H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pin_svg__b",
    width: 12,
    height: 8,
    x: 6,
    y: 25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2712_40721",
    stdDeviation: 1
  })))));
};
export default SvgPin;